// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2hB-G","icon":"index_icon_1W_Fx"};